// @flow @jsx h

import { Component, h } from 'preact'

import styles from './index.css'
import { SerumLazyResponsivePicture } from '@nrk/dh-feature-components'

type Props = {
  tittel: string,
  merkelapp: string,
  url: string,
  polopolyId: string,
  ratio: string,
  load: boolean
}

export class Inngang extends Component<Props> {
  elm: HTMLElement

  componentDidMount () {
    if (this.props.ratio) {
      this.elm.style.setProperty('--inngangHeight', this.props.ratio)
    }
  }

  componentDidUpdate (previousProps: Props) {
    if (this.props.ratio !== previousProps.ratio) {
      this.elm.style.setProperty('--inngangHeight', this.props.ratio)
    }
  }

  render () {
    const { tittel, merkelapp, url, polopolyId, load } = this.props
    return <a class={styles.inngang} href={url} ref={elm => (this.elm = elm)}>
      {polopolyId && <figure>
        <SerumLazyResponsivePicture
          id={polopolyId}
          alt=''
          sizes={'100vw'}
          ratio={'169'}
          load={load} />
      </figure>}
      <div class={styles.inngang__header}>
        <h4>{tittel}</h4>
        <div class={styles.inngang__merkelapp}>{merkelapp}</div>
        <svg aria-hidden>
          <use xlinkHref='#nrk-chevron-right' />
        </svg>
      </div>
    </a>
  }
}
